import { useMemo, useCallback, useState } from 'react';
import { Column } from 'react-table';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { Button, Dropdown, Menu, Select } from 'antd';
import * as Icons from '@ant-design/icons';

import { StopPropagation } from '@core/ui';
import { OverCell, tableColumns } from '@core/table';

import { ProductTypeQueryKeys } from '../../utils';
import { IProductType } from '../../interfaces';
import { useStatusByModelId } from '@modules/status';

export const useProductTypeTableColumns = () => {
  const history = useHistory();
  const location = useLocation();
  const status = useStatusByModelId('6');

  const actionsColumn = useMemo<Column<IProductType>>(
    () => ({
      ...tableColumns.actions,
      Cell: ({ row: { original } }) => {
        const [visible, setVisible] = useState<boolean>(false);

        const openEdit = useCallback(() => {
          history.push(generatePath('/@next/product-types/:id/update', { id: original.id }), { background: location });
        }, [original.id]);

        const overlay = (
          <Menu onClick={() => setVisible(false)}>
            <Menu.Item onClick={openEdit} icon={<Icons.EditOutlined />}>
              Düzəliş et
            </Menu.Item>
          </Menu>
        );

        return (
          <StopPropagation>
            <Dropdown visible={visible} onVisibleChange={setVisible} overlay={overlay}>
              <Button icon={<Icons.MoreOutlined />} size='small' />
            </Dropdown>
          </StopPropagation>
        );
      },
    }),
    [history, location],
  );
  return useMemo<Column<IProductType>[]>(
    () => [
      actionsColumn,
      {
        ...tableColumns.small,
        accessor: (row) => row.id,
        id: ProductTypeQueryKeys.id,
        Header: 'Kod',
      },
      {
        accessor: (row) => row.nameAz,
        id: ProductTypeQueryKeys.nameAz,
        Header: 'Azərbaycanca',
      },
      {
        accessor: (row) => row.nameTr,
        id: ProductTypeQueryKeys.nameTr,
        Header: 'Türkçe',
      },
      {
        accessor: (row) => row.nameEn,
        id: ProductTypeQueryKeys.nameEn,
        Header: 'English',
      },
      {
        accessor: (row) => row.nameRu,
        id: ProductTypeQueryKeys.nameRu,
        Header: 'По-русски',
        Cell: OverCell,
      },
      {
        ...tableColumns.small,
        accessor: (row) => row.status.name,
        id: ProductTypeQueryKeys.statusName,
        Header: 'Status',
        Filter: ({ column: { filterValue, setFilter } }) => {
          return (
            <Select allowClear={true} style={{ width: '100%' }} onChange={setFilter} value={filterValue}>
              {status.data?.map((status) => (
                <Select.Option key={status.id} value={status.name}>
                  {status.name}
                </Select.Option>
              ))}
            </Select>
          );
        },
        Cell: OverCell,
      },
      {
        ...tableColumns.small,
        accessor: (row) => row.customsParentId,
        id: ProductTypeQueryKeys.customsParentId,
        Header: 'Parent ID',
      },
    ],
    [actionsColumn, status],
  );
};
